import React, { FunctionComponent, useMemo, useState } from "react";
import {
  AttachedResource,
  AttachedResourceType,
  AttachedToType,
  ChecklistItem,
} from "../../../../../../../../store/onboarding/cases/types";
import { Form, Modal, Spinner } from "react-bootstrap";
import { bindActionCreators, Dispatch } from "redux";
import { uploadDocument } from "../../../../../../../../store/onboarding/actions";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";

type OwnProps = {
  onClose: () => void;
  onAttachmentsAdd: (resources: AttachedResource[]) => any;
};

type DispatchProps = {
  uploadDocument: (attachedResource: AttachedResource) => any;
};

type Props = OwnProps & DispatchProps;

const UploadUrlModal: FunctionComponent<Props> = ({
  onClose,
  onAttachmentsAdd,
  uploadDocument,
}) => {
  const [fileUploading, setFileUploading] = useState<boolean>(false);
  const defaultUrlResource: AttachedResource = useMemo(
    () => ({
      attached_to_type: AttachedToType.CHECKLIST_ITEM,
      resource_type: AttachedResourceType.URL,
      title: "",
      url: "",
    }),
    []
  );

  const [resource, setResource] = useState(defaultUrlResource);

  const handleResourceChange = (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target as HTMLInputElement;
    setResource((resource) => ({ ...resource, [name]: value }));
  };

  const handleAddResource = (event: React.FormEvent<any>) => {
    event.preventDefault();
    setFileUploading(true);
    uploadDocument(resource).then(
      (res: AttachedResource) => {
        onAttachmentsAdd([res]);
        setFileUploading(false);
        onClose();
      },
      (err: string) => {
        toastr.error("File Upload Error", defaultUrlResource.title + err);
        setFileUploading(false);
      }
    );
  };

  return (
    <Modal
      show={true}
      onHide={onClose}
      animation={false}
      backdropClassName="customDarkModalBackdrop inner in"
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        closeButton
        className={`purpleModalHeader`}
      >
        <Modal.Title>Enter URL</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form id="urlResource" onSubmit={handleAddResource}>
          <Form.Group>
            <Form.Label column={false} className="font-weight-bold text-left">
              Resource Title
            </Form.Label><span className="label-asterisk">*</span>
            <Form.Control
              required
              placeholder="Enter"
              name="title"
              value={resource.title}
              onChange={handleResourceChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label column={false} className="font-weight-bold text-left">
              Resource URL
            </Form.Label><span className="label-asterisk">*</span>
            <Form.Control
              required
              placeholder="https://www.example.com"
              name="url"
              type="url"
              value={resource.url || ""}
              onChange={handleResourceChange}
            />
          </Form.Group>
        </Form>

        <div className="btnActions">
          <button className="whiteBtnSm" onClick={onClose}>
            CANCEL
          </button>
          <button className="blueBtnSm" form="urlResource" type="submit">
            ADD URL {fileUploading && <Spinner animation="border" size="sm" />}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => {
  return bindActionCreators(
    {
      uploadDocument: uploadDocument,
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(UploadUrlModal);
